/** Istilah operasional dapur — konsisten di seluruh PWA. */
export const kitchenTerms = {
  appName: 'Superoti Dapur',
  modules: {
    home: 'Beranda',
    production: 'Produksi',
    dispatch: 'Distribusi',
    stock: 'Stok',
    waste: 'Pemusnahan',
    attendance: 'Absensi',
    kitchenTransfer: 'Antar dapur',
    warehouseReceive: 'Terima dari gudang',
    warehouseReturn: 'Retur ke gudang',
  },
  roles: {
    headKitchen: 'Kepala dapur',
  },
  shell: {
    logout: 'Keluar',
  },
  production: {
    plan: 'Plan HO',
    session: 'Sesi produksi',
    postStock: 'Masuk stok',
    saveDraft: 'Simpan hasil produksi',
    planTitle: 'Plan produksi hari ini',
    sessionTitle: 'Sesi produksi',
    editTitle: 'Isi hasil',
    reviewTitle: 'Konfirmasi masuk stok',
    brdHint: 'Plan HO adalah rekomendasi — boleh produksi lebih atau kurang dari target.',
    formulaHint:
      'Kebutuhan produksi = plan − stok good − kiriman hari ini. Rincian aktual per sesi ada di PDF.',
    tableLegend:
      'Stok = stok good dapur. Produksi = kebutuhan tersisa. Aktual = total input yang sudah disimpan.',
    progressLabel: 'Progress aktual vs kebutuhan',
    planStatusPublished: 'dipublikasi HO',
    planStatusNone: 'belum ada plan',
    planTargetLabel: (statusLabel: string) => `Target gabungan semua plan HO · ${statusLabel}`,
    showPlanDetails: (count: number) => `Lihat ${count} plan dari HO`,
    hidePlanDetails: 'Sembunyikan detail plan',
    startToday: 'Mulai input hari ini',
    continueInput: 'Lanjut input produksi',
    downloadPdf: 'Unduh PDF',
    downloadingPdf: 'Mengunduh…',
    sessionListHint: 'Buat sesi kapan saja sesuai kebutuhan dapur.',
    pickOtherDate: 'Atau pilih tanggal lain',
    filterTodo: 'Belum masuk stok',
    filterHistory: 'Sudah masuk stok',
    badgePosted: 'Sudah masuk stok',
    continueFill: 'Lanjut isi',
    viewDetail: 'Lihat detail',
    emptyTodo: 'Belum ada input produksi hari ini.',
    emptyHistory: 'Belum ada produksi yang sudah masuk stok.',
    backHome: 'Kembali ke beranda',
    back: 'Kembali',
    summaryVsPlan: 'Ringkasan vs plan HO',
    noteLabel: 'Catatan (opsional)',
    notePlaceholder: 'Contoh: Oven 2 delay 15 menit',
    postedReadonly: 'Input ini sudah masuk stok dan tidak bisa diubah.',
    footerSaveHint: 'Simpan dulu kalau belum selesai. Masuk stok = final, tidak bisa diubah.',
    confirmPost: 'Konfirmasi dengan PIN',
    reviewHint:
      'Periksa hasil produksi sebelum masuk stok. Setelah dikonfirmasi, data tidak bisa diubah.',
    totalLabel: 'Total',
    note: 'Catatan',
    qtyLabel: 'Jumlah',
    pcs: 'pcs',
    columns: {
      product: 'Produk',
      stock: 'Stok',
      plan: 'Plan',
      need: 'Produksi',
      actual: 'Aktual',
    },
    flowSteps: ['Isi hasil', 'Konfirmasi', 'Masuk stok'] as const,
    pin: {
      title: 'PIN konfirmasi',
      description: 'Masukkan PIN 6 digit kepala dapur untuk memasukkan hasil ke stok.',
      confirm: 'Konfirmasi masuk stok',
    },
    create: {
      title: 'Mulai input produksi',
      hint: 'Produk dari plan HO akan muncul otomatis. Isi jumlah hasil produksi.',
      dateLabel: 'Tanggal produksi',
      sessionTitleLabel: (title: string) => `Judul sesi: ${title}`,
      start: 'Mulai',
      cancel: 'Batal',
    },
    deleteConfirm: {
      title: 'Hapus input kosong?',
      message: 'Sesi tanpa jumlah produksi akan dihapus dari daftar.',
      confirm: 'Hapus',
      cancel: 'Batal',
    },
    hints: {
      stockEnough: 'Stok sudah cukup untuk rencana',
      needProduction: (need: number) => `Perlu produksi ${need} pcs`,
      outsideNeed: 'Input di luar kebutuhan (stok cukup)',
      needMet: 'Kebutuhan terpenuhi',
      overNeed: (diff: number) => `Lebih ${diff} pcs dari kebutuhan`,
      underNeed: (diff: number) => `Kurang ${diff} pcs dari kebutuhan`,
    },
    sessionSummary: {
      empty: 'Belum ada produk diisi',
      filled: (skuCount: number, totalQty: number) => `${skuCount} produk · ${totalQty} pcs`,
    },
    toast: {
      pdfNeedsApi: 'Unduh PDF membutuhkan koneksi API.',
      pdfSuccess: 'File PDF plan produksi berhasil diunduh.',
      pdfFailed: 'Gagal unduh PDF plan produksi.',
      sessionCreated: 'Input produksi dibuat. Isi jumlah hasilnya.',
      noPlan: 'Belum ada plan HO untuk hari ini.',
      deleted: 'Input kosong dihapus.',
      saved: 'Hasil produksi disimpan.',
      posted: (totalQty: number, syncQueued: boolean) =>
        `${totalQty} pcs sudah masuk stok.${syncQueued ? ` ${kitchenTerms.sync.queued}` : ''}`,
      saveMinOne: 'Isi minimal 1 produk dengan jumlah lebih dari 0.',
    },
    errors: {
      loadFailed: 'Gagal memuat data produksi.',
      dateRequired: 'Tanggal produksi wajib diisi.',
      noPlan: 'Belum ada plan HO untuk hari ini.',
      deviceRequired: 'Perangkat tidak terdaftar. Aktivasi ulang diperlukan.',
    },
    loadError: 'Gagal memuat data produksi — periksa koneksi lalu coba lagi.',
    retry: 'Coba lagi',
    refreshAria: 'Perbarui produksi',
    empty: {
      planTitle: 'Belum ada plan HO',
      planDescription: 'Plan produksi dari Head Office belum tersedia untuk hari ini.',
    },
    loadingPlan: 'Memuat plan dari server',
    updated: 'Diperbarui',
    created: 'Baru dibuat',
    deleteAria: 'Hapus input kosong',
  },
  dispatch: {
    title: 'Distribusi ke toko',
    subtitleHint:
      'Dapur menentukan toko tujuan, produk, dan jumlah kirim. Pilih delman yang mengantar.',
    todayList: 'Pengiriman hari ini',
    generate: 'Generate distribusi',
    generating: 'Mengenerate…',
    downloadPdf: 'Unduh PDF',
    downloadingPdf: 'Mengunduh…',
    backHome: 'Kembali ke beranda',
    back: 'Kembali',
    loading: 'Memuat pengiriman hari ini',
    loadError: 'Gagal memuat data distribusi — menampilkan data lokal jika ada.',
    retry: 'Coba lagi',
    filters: {
      pending: 'Belum diserahkan',
      inTransit: 'Sudah ke delman',
      received: 'Toko terima',
    },
    sections: {
      readyHandover: 'Siap diserahkan ke delman',
      needsWork: 'Perlu dilengkapi',
    },
    status: {
      draft: 'Belum disimpan',
      draftShort: 'Draft',
      prepared: 'Belum diserahkan',
      preparedShort: 'Siap serah',
      inTransit: 'Sudah ke delman',
      inTransitShort: 'Ke delman',
      received: 'Toko sudah terima',
      receivedShort: 'Toko terima',
    },
    flowSteps: ['Atur kirim', 'Serah delman', 'Toko terima'] as const,
    card: {
      delmanPrefix: 'Delman',
      emptyProducts: 'Belum ada produk ditambahkan',
      productsSummary: (count: number, qty: number) => `${count} produk · ${qty} pcs`,
      handover: 'Serahkan ke delman',
      arrange: 'Atur pengiriman',
      viewDetail: 'Lihat detail',
      deleteAria: 'Hapus pengiriman kosong',
      storesBadge: (n: number) => `${n} toko`,
    },
    zeroStock: {
      bannerTitle: 'Belum ada stok siap kirim',
      bannerBody:
        'Distribusi butuh barang yang sudah diproduksi. Catat produksi dulu — setelah masuk stok dapur, baru generate ke toko.',
      goProduction: 'Ke Produksi',
      generateDisabledHint: 'Butuh stok dapur terlebih dahulu',
      modalTitle: 'Stok dapur masih kosong',
      modalBody:
        'Rencana HO hanya target jumlah. Input hasil produksi dulu, lalu generate distribusi.',
      stockSummaryZero: (hoPlanPcs: number, productCount: number) =>
        `Stok dapur hari ini: 0 pcs${hoPlanPcs > 0 ? ` · ${hoPlanPcs} pcs rencana HO (${productCount} produk)` : ''}`,
      stockSummaryPartial: (stockPcs: number, hoPlanPcs: number) =>
        `Stok dapur: ${stockPcs} pcs · Rencana HO: ${hoPlanPcs} pcs — jika stok kurang, qty dibagi proporsional per produk.`,
      editorEmptyTitle: 'Belum ada barang untuk dikirim',
      editorEmptyBody:
        'Stok dapur kosong atau belum sesuai rencana HO. Kembali ke Produksi atau tunggu stok tersedia.',
    },
    empty: {
      pending: {
        title: 'Belum ada pengiriman hari ini',
        description:
          'Setelah produksi dicatat dan stok dapur tersedia, generate distribusi dari rencana HO untuk menyiapkan kiriman ke toko.',
      },
      inTransit: {
        title: 'Belum ada barang ke delman',
        description: 'Pengiriman yang sudah diserahkan ke delman akan muncul di sini.',
      },
      received: {
        title: 'Belum ada penerimaan toko',
        description: 'Toko yang sudah selesai scan QR penerimaan akan muncul di sini.',
      },
    },
    editor: {
      stockAvailable: 'Stok dapur tersedia',
      stockProducts: (n: number) => `(${n} produk)`,
      stockHint:
        'Total per produk (tanggal = batch terbaru), sudah dikurangi qty pengiriman lain hari ini.',
      storeLabel: 'Toko:',
      delmanLabel: 'Delman:',
      storeDelmanFixed: 'Toko & delman ditetapkan saat generate distribusi.',
      noProducts: 'Belum ada produk di rencana HO atau stok dapur untuk toko ini.',
      productionDate: (date: string) => `Produksi ${date}`,
      maxShip: (limit: number) => ` · Maks kirim ${limit} pcs`,
      maxShipPlan: (plan: number) => ` · Target rencana ${plan} pcs`,
      planToStore: (store: string, qty: number) => `Rencana ke ${store}: ${qty} pcs`,
      planRemaining: (qty: number) => `Sisa rencana ${qty} pcs`,
      qtyLabel: 'Jumlah kirim',
      removeProductAria: 'Hapus produk',
      overMax: (limit: number) => `Melebihi maks kirim (${limit} pcs)`,
      totalShip: 'Total kirim',
      receivedReadonly: 'Toko sudah menerima barang. Tidak bisa diubah.',
      footerHint: 'Simpan dulu kalau belum selesai. Serah ke delman = final, tidak bisa diubah.',
      save: 'Simpan pengiriman',
      saving: 'Menyimpan…',
      handover: 'Serahkan ke delman',
    },
    review: {
      title: 'Konfirmasi serah ke delman',
      hint: 'Periksa pengiriman sebelum diserahkan. Setelah dikonfirmasi, data tidak bisa diubah.',
      confirmPin: 'Konfirmasi dengan PIN',
      productionDate: (date: string) => `Produksi ${date}`,
      totalLabel: 'Total',
    },
    pin: {
      title: 'PIN konfirmasi',
      description: 'Masukkan PIN 6 digit kepala dapur untuk menyerahkan barang ke delman.',
      confirm: 'Konfirmasi serah ke delman',
    },
    dadakanWarning: {
      title: 'Ada jadwal kirim besok belum diserahkan',
      bodyGenerate:
        'Masih ada draft kiriman besok yang belum PIN. Generate hari ini bisa memakai stok yang sama — pastikan qty jadwal besok masih cukup, atau ubah dulu sebelum lanjut.',
      bodyHandover:
        'Masih ada draft kiriman besok (belum PIN) dengan produk yang sama. Setelah PIN, stok terkunci untuk hari ini. Jadwal besok mungkin perlu dikurangi.',
      storesLabel: 'Jadwal besok terkait',
      storeLine: (store: string, products: string[]) =>
        products.length > 0 ? `${store}: ${products.join(', ')}` : store,
      cancel: 'Batal',
      continue: 'Lanjut saja',
    },
    create: {
      title: 'Generate distribusi',
      hint:
        'Pilih tanggal kirim (hari ini atau besok), toko, dan delman. Jika stok tidak cukup, qty dibagi proporsional. Draft pada tanggal yang sama akan diperbarui; generate hari ini dan besok untuk toko yang sama tetap terpisah.',
      tripDateLabel: 'Tanggal kirim',
      tripDateToday: 'Hari ini',
      tripDateTomorrow: 'Besok',
      tripDateTomorrowDisabledHint: 'Belum ada rencana HO untuk besok.',
      outletsLabel: 'Toko tujuan',
      noOutlets: 'Belum ada outlet terhubung dengan dapur ini.',
      loadingPlans: 'Memuat rencana toko…',
      noHoPlan: 'Tidak ada rencana HO untuk tanggal ini — tidak bisa dipilih',
      hoPlanPcs: (qty: number) => `${qty} pcs rencana HO`,
      selectedSummary: (stores: number, total: number) =>
        `${stores} toko terpilih · ${total} pcs rencana HO (gabungan)`,
      delmanLabel: 'Delman pengantar',
      noDelmans: 'Belum ada delman terhubung dengan dapur ini.',
      cancel: 'Batal',
      generate: 'Generate',
      closeAria: 'Tutup',
      errors: {
        noSelectableOutlets: 'Belum ada toko dengan rencana HO hari ini.',
        selectOutletDelman: 'Pilih minimal satu toko dan delman.',
        needsApi: 'Generate distribusi membutuhkan koneksi API.',
        generateFailed: 'Gagal generate distribusi.',
        noStock:
          'Generate dibatalkan — tidak ada stok dapur untuk produk di rencana HO. Input produksi dulu.',
      },
    },
    toast: {
      pdfNeedsApi: 'Unduh PDF membutuhkan koneksi API.',
      pdfSuccess: 'PDF distribusi berhasil diunduh.',
      pdfFailed: 'Gagal unduh PDF distribusi.',
      deleted: 'Pengiriman kosong dihapus.',
      saved: (syncQueued: boolean) =>
        `Pengiriman disimpan. Bisa dilanjutkan nanti.${syncQueued ? ` ${kitchenTerms.sync.queued}` : ''}`,
      generated: (count: number, skipped: number) =>
        skipped > 0
          ? `${count} kiriman dibuat/diperbarui. ${skipped} toko dilewati.`
          : `${count} kiriman distribusi digenerate. Periksa jumlah per toko.`,
      noStockGenerated:
        'Tidak ada kiriman dibuat — stok dapur kosong untuk produk di rencana HO. Input produksi dulu.',
      handover: (qty: number, store: string, delman: string, syncQueued: boolean) =>
        `${qty} pcs ke ${store} diserahkan ke ${delman}.${syncQueued ? ` ${kitchenTerms.sync.queued}` : ''}`,
    },
    generateResult: {
      titleSingle: (store: string) => `Hasil · ${store}`,
      titleMulti: (n: number) => `Hasil generate · ${n} toko`,
      tripSubtitle: (label: string) => label,
      summaryReady: (store: string, lines: number, qty: number) =>
        `${store}: kiriman siap (${lines} baris · qty ${qty}).`,
      summaryMulti: (n: number, skipped: number) =>
        skipped > 0
          ? `${n} kiriman dibuat/diperbarui. ${skipped} toko tidak mendapat kiriman baru.`
          : `${n} kiriman dibuat/diperbarui.`,
      summaryNone: 'Tidak ada kiriman baru.',
      sectionCreated: 'Dibuat / diperbarui',
      sectionSkipped: 'Tidak mendapat kiriman baru',
      deliveryRow: (code: string, lines: number, qty: number) =>
        `${code} · ${lines} baris · qty ${qty}`,
      heldSection: 'Produk ditahan (stok 0)',
      heldRow: (name: string, need: number) => `${name} · sisa ${need}`,
      heldBanner: (store: string, lines: number, held: number) =>
        `${store}: ${lines} baris masuk draft. ${held} produk ditahan — stok dapur 0.`,
      ctaView: 'Lihat kiriman',
      ctaProduction: 'Ke Produksi',
      ctaClose: 'Tutup',
    },
    errors: {
      loadFailed: 'Gagal memuat data distribusi.',
      saveMinOne: 'Tambahkan minimal 1 produk dengan jumlah lebih dari 0.',
      overStock: (product: string, limit: number) =>
        `${product}: maks ${limit} pcs (stok dapur tersisa setelah pengiriman toko lain). Kurangi jumlah atau produksi dulu.`,
      overPlan: (product: string, plan: number) =>
        `${product}: maks ${plan} pcs sesuai rencana HO ke toko ini (stok sudah cukup).`,
      saveFailed: 'Gagal menyimpan pengiriman.',
      handoverFailed: 'Gagal menyerahkan ke delman.',
    },
    handover: 'Serah ke delman',
    saveDraft: 'Simpan pengiriman',
    completeAndHandover: 'Lengkapi lalu serahkan ke delman',
    inTransit: 'Sudah ke delman',
    received: 'Toko sudah terima',
  },
  waste: {
    title: 'Pemusnahan',
    subtitleHint:
      'Stok baru berkurang setelah batch dimusnahkan di dapur (bukan saat HO menyetujui).',
    stockStages: [
      { step: '1', label: 'Kirim ke HO', detail: 'Stok belum berubah' },
      { step: '2', label: 'HO setuju', detail: 'Stok belum berubah' },
      { step: '3', label: 'Musnah + foto', detail: 'Stok berkurang' },
    ] as const,
    proposal: 'Proposal pemusnahan',
    newProposal: 'Proposal baru',
    loading: 'Memuat batch pemusnahan hari ini',
    loadError: 'Gagal memuat data pemusnahan — menampilkan data lokal jika ada.',
    retry: 'Coba lagi',
    backHome: 'Kembali ke beranda',
    back: 'Kembali',
    backToList: 'Kembali ke daftar',
    todayBatches: 'Batch hari ini',
    wasteStockNow: 'Stok waste sekarang',
    stockAvailableToday: 'Stok tersedia hari ini',
    flowSteps: ['Buat', 'Kirim HO', 'Setuju', 'Musnah'] as const,
    filters: {
      draft: 'Belum dikirim',
      submitted: 'Menunggu HO',
      approved: 'Siap musnah',
      done: 'Selesai',
      rejectedBadge: 'ada ditolak',
    },
    status: {
      draft: 'Belum dikirim',
      submitted: 'Menunggu HO',
      approved: 'Siap dimusnahkan',
      rejected: 'Ditolak HO',
      done: 'Selesai',
    },
    stockSources: {
      main: {
        label: 'Stok bagus',
        shortLabel: 'Stok bagus',
        hint: 'Stok bagus di dapur yang siap kirim — wajib isi alasan per produk.',
      },
      return: {
        label: 'Stok waste',
        shortLabel: 'Stok waste',
        hint: 'Stok waste dari retur toko — tidak perlu alasan (memang harus dimusnahkan).',
      },
    },
    card: {
      emptyItems: 'Belum ada item',
      itemsSummary: (count: number, qty: number) => `${count} item · ${qty} pcs`,
      batchIdLabel: (id: string) => id,
      continueEdit: 'Lanjut edit',
      execute: 'Musnah & lapor',
      viewDetail: 'Lihat detail',
      recreate: 'Buat ulang proposal',
      deleteAria: 'Hapus proposal kosong',
      sourceBreakdown: (parts: string[]) => parts.join(' · '),
    },
    empty: {
      draft: {
        title: 'Belum ada proposal',
        description: 'Buat proposal pemusnahan untuk mengajukan pembuangan stok ke Head Office.',
      },
      submitted: {
        title: 'Tidak ada yang menunggu HO',
        description: 'Proposal yang sudah dikirim akan muncul di sini sampai disetujui atau ditolak.',
      },
      approved: {
        title: 'Tidak ada batch siap dimusnahkan',
        description: 'Batch yang sudah disetujui HO siap dieksekusi dengan foto bukti.',
      },
      done: {
        title: 'Belum ada pemusnahan selesai',
        description: 'Riwayat pemusnahan yang sudah selesai dan stok sudah berkurang.',
      },
    },
    editor: {
      addItem: '+ Tambah item',
      noItems: 'Belum ada item. Tambahkan produk yang akan dimusnahkan.',
      fifoHint:
        'Cukup pilih produk dan jumlah. Sistem mengambil lot produksi terlama dulu. Detail lot muncul setelah dikirim ke HO.',
      stockLimit: (limit: number) => `Tersedia ${limit} pcs`,
      overStock: (limit: number) => `Melebihi stok tersedia (${limit} pcs)`,
      reasonLabel: 'Alasan pemusnahan *',
      reasonPlaceholder: 'Contoh: Kadaluarsa, rusak kemasan, sisa closing',
      reasonTitle: 'Alasan',
      proposalNoteLabel: 'Catatan proposal',
      proposalNotePlaceholder: 'Opsional — catatan umum proposal',
      totalLabel: 'Total',
      footerHint: 'Stok belum berubah sampai pemusnahan selesai.',
      saveDraft: 'Simpan draft',
      submitHo: 'Kirim ke HO',
      removeItemAria: 'Hapus item',
      checklistTitle: 'Checklist sebelum kirim',
      checklistItems: 'Minimal 1 item ditambahkan',
      checklistReasons: 'Alasan stok bagus sudah diisi',
      checklistStock: 'Jumlah tidak melebihi stok tersedia',
    },
    review: {
      title: 'Konfirmasi kirim ke HO',
      subtitle: 'Periksa proposal sebelum dikirim',
      summaryTitle: 'Ringkasan proposal',
      summaryQty: (count: number, qty: number) => `${count} item · ${qty} pcs total`,
      noteLabel: 'Catatan',
      lotBreakdownTitle: 'Alokasi lot (FIFO)',
      lotLine: (date: string, qty: number) => `prod. ${date} · ${qty} pcs`,
      warning:
        'Setelah dikirim, stok belum berubah sampai HO menyetujui dan pemusnahan selesai.',
      confirmPin: 'Konfirmasi dengan PIN',
    },
    execute: {
      title: (batchId: string) => `Musnah · ${batchId}`,
      subtitle: 'Item disetujui HO',
      warning: 'Setelah dikonfirmasi, status selesai dan stok langsung berkurang.',
      checklistTitle: 'Checklist sebelum selesai',
      noteFilled: 'Catatan pemusnahan diisi',
      photoFilled: (count: number) => `Min. 1 foto bukti (${count} terlampir)`,
      noteLabel: 'Catatan pemusnahan *',
      notePlaceholder: 'Contoh: Sudah dibuang ke tempat sampah dapur',
      photoLabel: 'Foto bukti * (min 1)',
      addPhoto: 'Ambil / pilih foto',
      addMorePhoto: 'Tambah foto lagi',
      removePhotoAria: 'Hapus foto',
      photoAlt: (index: number) => `Bukti ${index}`,
      finish: 'Selesai & kurangi stok',
      itemSummary: (qty: number, date?: string) =>
        date ? `${qty} pcs · prod. ${date}` : `${qty} pcs`,
    },
    detail: {
      title: 'Detail pemusnahan',
      rejectionTitle: 'Alasan penolakan HO',
      proposalNote: 'Catatan proposal',
      lotBreakdownHint:
        'Qty per tanggal produksi dialokasikan otomatis (lot terlama dulu) saat proposal dikirim.',
      executionNote: 'Catatan pemusnahan',
      photos: 'Foto bukti',
    },
    timeline: {
      title: 'Riwayat',
      submitted: 'Dikirim ke HO',
      rejected: 'Ditolak HO',
      approved: 'Disetujui HO',
      executed: 'Pemusnahan selesai',
    },
    addItem: {
      title: 'Tambah item',
      closeAria: 'Tutup',
      sourceLabel: 'Sumber stok',
      productLabel: 'Pilih produk',
      searchPlaceholder: 'Cari produk…',
      noSearchResults: 'Produk tidak ditemukan.',
      noStock: (source: string) =>
        `Tidak ada stok ${source.toLowerCase()} tersedia untuk ditambahkan.`,
      productOption: (available: number) => `${available} pcs tersedia`,
      qtyLabel: 'Jumlah',
      fillMax: (limit: number) => `Isi maks (${limit})`,
      cancel: 'Batal',
      confirm: 'Tambah',
      preview: (product: string, qty: number, source: string) => `${product} · ${qty} pcs · ${source}`,
    },
    confirm: {
      deleteItemTitle: 'Hapus item?',
      deleteItemMessage: (label: string) => `Hapus "${label}" dari proposal ini?`,
      deleteBatchTitle: 'Hapus proposal kosong?',
      deleteBatchMessage: 'Proposal kosong akan dihapus permanen dari daftar draft.',
      delete: 'Hapus',
      cancel: 'Batal',
    },
    pin: {
      submit: {
        title: 'PIN konfirmasi',
        description: 'Masukkan PIN 6 digit kepala dapur untuk mengirim proposal ke HO.',
        confirm: 'Kirim ke HO',
      },
      execute: {
        title: 'PIN konfirmasi',
        description:
          'Masukkan PIN 6 digit kepala dapur untuk menyelesaikan pemusnahan dan mengurangi stok.',
        confirm: 'Selesai pemusnahan',
      },
    },
    toast: {
      created: 'Proposal pemusnahan baru dibuat.',
      saved: 'Proposal pemusnahan disimpan.',
      itemRemoved: 'Item dihapus dari proposal.',
      batchDeleted: 'Proposal kosong dihapus.',
      recreated: 'Proposal baru dibuat dari penolakan HO.',
      submitted: (syncQueued: boolean) =>
        `Proposal dikirim ke HO. Stok belum berubah.${syncQueued ? ` ${kitchenTerms.sync.queued}` : ''}`,
      executed: (syncQueued: boolean) =>
        `Pemusnahan selesai. Stok sudah berkurang.${syncQueued ? ` ${kitchenTerms.sync.queued}` : ''}`,
    },
    errors: {
      loadFailed: 'Gagal memuat data pemusnahan.',
      deviceRequired: 'Perangkat tidak terdaftar.',
      saveMinOne: 'Tambahkan minimal 1 item dengan jumlah lebih dari 0.',
      overStock: (product: string, source: string, limit: number) =>
        `Stok ${product} (${source}) tidak cukup. Tersedia ${limit} pcs.`,
      reasonRequired: (product: string) =>
        `Isi alasan untuk ${product} (stok bagus wajib ada alasan).`,
      pickProduct: 'Pilih produk dari stok dapur.',
      qtyPositive: 'Jumlah harus lebih dari 0.',
      insufficientStock: (limit: number) => `Stok tidak cukup. Tersedia ${limit} pcs.`,
      duplicateProduct: 'Produk ini sudah ada di proposal.',
      executionNoteRequired: 'Isi catatan pemusnahan.',
      photoRequired: 'Lampirkan minimal 1 foto bukti.',
      submitFailed: 'Gagal mengirim proposal ke HO.',
      executeFailed: 'Gagal menyelesaikan pemusnahan.',
    },
    created: 'Baru dibuat',
    createdFromRejection: 'Baru dibuat dari penolakan HO',
    savedAt: 'Disimpan',
    submittedAt: 'Dikirim',
    goodStock: 'Stok bagus',
    wasteStock: 'Stok waste',
    materialStock: 'Bahan baku',
    submitHo: 'Kirim ke HO',
    executeLabel: 'Eksekusi pemusnahan',
  },
  stock: {
    title: 'Stok dapur',
    subtitle: (time: string) => `Stok real-time dari ledger dapur · diperbarui ${time}`,
    refreshAria: 'Perbarui stok',
    loading: 'Memuat stok dapur',
    loadError: 'Gagal memuat stok — periksa koneksi lalu coba lagi.',
    retry: 'Coba lagi',
    backHome: 'Kembali ke beranda',
    tabs: {
      product: 'Produk jadi',
      material: 'Bahan baku',
    },
    summary: {
      products: 'Produk',
      productionDates: 'Tanggal prod.',
      goodStock: 'Stok bagus',
      wasteStock: 'Stok waste',
      materialTypes: 'Jenis bahan',
      materialTotal: 'Total saldo',
    },
    filters: {
      all: 'Semua',
      good: 'Stok bagus',
      waste: 'Stok waste',
    },
    search: {
      productPlaceholder: 'Cari nama produk...',
      materialPlaceholder: 'Cari bahan baku...',
      productAria: 'Cari produk',
      materialAria: 'Cari bahan baku',
    },
    product: {
      lotsSummary: (dates: number, total: number) =>
        `${dates} tanggal produksi · ${total} pcs total`,
      productionDate: (date: string) => `Tanggal produksi ${date}`,
      qty: (n: number) => `${n} pcs`,
    },
    material: {
      uomLabel: (uom: string) => `${kitchenTerms.waste.materialStock} · ${uom}`,
      qty: (n: number, uom: string) => `${n} ${uom}`,
    },
    empty: {
      productTitle: 'Tidak ada stok',
      productSearch: 'Tidak ada produk yang cocok dengan pencarian.',
      productFilter: 'Belum ada stok tercatat di dapur untuk filter ini.',
      materialTitle: 'Tidak ada stok bahan baku',
      materialSearch: 'Tidak ada bahan yang cocok dengan pencarian.',
      materialDefault: 'Belum ada saldo bahan baku di dapur ini.',
    },
    hint: 'Stok bagus siap distribusi. Stok waste dari retur toko — perlu pemusnahan terpisah.',
  },
  attendance: {
    title: 'Absensi tim dapur',
    subtitle: (kitchenName: string, dateLabel: string) => `${kitchenName} · ${dateLabel}`,
    nowClock: (time: string, shiftStart: string) =>
      `Sekarang ${time} · Shift mulai ${shiftStart}`,
    teamShiftStart: '06:00',
    hint: 'Tablet dipakai bergantian — tiap orang pilih nama sendiri, selfie, lalu PIN pribadi.',
    loading: 'Memuat daftar tim dapur',
    loadError: 'Gagal memuat absensi — periksa koneksi lalu coba lagi.',
    retry: 'Coba lagi',
    refreshAria: 'Perbarui absensi',
    backHome: 'Kembali ke beranda',
    checkIn: 'Masuk',
    checkOut: 'Keluar',
    checkInVerb: 'masuk',
    checkOutVerb: 'keluar',
    notYet: 'Belum masuk',
    onShift: 'Sedang shift',
    finished: 'Selesai',
    onTime: 'Tepat waktu',
    late: 'Terlambat',
    duration: (hours: number, minutes: number) => `Durasi: ${hours}j ${minutes}m`,
    checkInTeam: 'Masuk tim',
    progress: (checkedIn: number, total: number) => `${checkedIn}/${total} orang`,
    finishedCount: (n: number) => `Selesai shift: ${n} orang`,
    notCheckedInNames: (names: string) => `Belum masuk: ${names}`,
    missingAlert: (count: number) =>
      `${count} orang belum masuk padahal shift sudah dimulai.`,
    roleGroupSummary: (checkedIn: number, total: number) => `${checkedIn}/${total} sudah masuk`,
    checkOutAction: 'Keluar · selfie + PIN',
    flowSteps: ['Pilih', 'Selfie', 'Konfirmasi', 'PIN'] as const,
    flow: {
      cancel: 'Batal',
      continueConfirm: 'Lanjut konfirmasi',
      continuePin: 'Lanjut ke PIN',
      retakeSelfie: 'Ulangi selfie',
      confirmHint: 'Pastikan nama dan foto sudah benar sebelum PIN',
      pinStaffHint: (name: string) => `Gunakan PIN pribadi ${name}.`,
    },
    confirm: {
      name: 'Nama',
      role: 'Peran',
      action: 'Aksi',
      time: 'Waktu',
    },
    pin: {
      title: (actionLabel: string) => `Konfirmasi ${actionLabel}`,
      description: (name: string, actionLabel: string) =>
        `PIN ${name} untuk ${actionLabel}.`,
      confirm: 'Submit absensi',
    },
    selfie: {
      required: 'Ambil selfie terlebih dahulu.',
      alt: (name: string) => `Selfie ${name}`,
      confirmAlt: (name: string) => `Konfirmasi ${name}`,
      checkInThumb: 'Masuk',
      checkOutThumb: 'Keluar',
    },
    toast: {
      checkIn: (name: string, verb: string, time: string, onTime: boolean, syncQueued: boolean) => {
        const timing = onTime ? ` · ${kitchenTerms.attendance.onTime}` : ` · ${kitchenTerms.attendance.late}`
        const base = `${name} ${verb} ${time}${timing}`
        return syncQueued ? `${base} · ${kitchenTerms.sync.queued}` : base
      },
      checkOut: (name: string, verb: string, time: string, syncQueued: boolean) => {
        const base = `${name} ${verb} ${time}`
        return syncQueued ? `${base} · ${kitchenTerms.sync.queued}` : base
      },
    },
    errors: {
      incomplete: 'Data absensi tidak lengkap.',
    },
    empty: {
      title: 'Belum ada tim terdaftar',
      description: 'Daftar staff dapur belum tersedia. Hubungi Admin HO jika seharusnya sudah ada.',
    },
  },
  kitchenTransfer: {
    send: {
      title: 'Kirim ke dapur lain',
      subtitle: 'Stok bagus dapur → delman → dapur tujuan',
    },
    receive: {
      title: 'Terima dari dapur lain',
      subtitle: 'Scan QR delman lalu konfirmasi penerimaan',
    },
    tabs: {
      send: 'Kirim',
      receive: 'Terima',
    },
    backHome: 'Kembali ke beranda',
    loading: 'Memuat transfer hari ini',
    loadError: 'Gagal memuat data transfer — periksa koneksi lalu coba lagi.',
    retry: 'Coba lagi',
    refreshAria: 'Perbarui transfer',
    mockHint: 'Mode mock — aktifkan API untuk data live.',
    flowSteps: {
      send: ['Daftar', 'Isi kiriman', 'Serah delman'] as const,
      receive: ['Daftar', 'Scan QR', 'Konfirmasi'] as const,
    },
    status: {
      draft: 'Draft',
      inTransit: 'Dalam perjalanan',
      received: 'Sudah diterima',
    },
    summary: {
      noLines: 'Belum ada baris',
      productCount: (n: number) => `${n} produk`,
      materialCount: (n: number) => `${n} bahan`,
      totalQty: (qty: number) => `${qty} qty`,
      join: (parts: string[], qty: number) =>
        parts.length === 0 ? 'Belum ada baris' : `${parts.join(' · ')} · ${qty} qty`,
    },
    stock: {
      none: 'Belum ada stok bagus di dapur',
      previewMore: (n: number) => ` +${n} lainnya`,
      availableLabel: 'Stok bagus tersedia',
    },
    sendList: {
      draftSection: 'Belum diserahkan ke delman',
      sentSection: 'Sudah ke delman',
      continueEdit: 'Lanjut isi',
      emptyTitle: 'Belum ada kiriman hari ini',
      emptyDescription: 'Buat kiriman baru ke dapur lain. Hanya stok bagus yang bisa dipindahkan.',
      newTransfer: '+ Kirim ke dapur lain',
    },
    editor: {
      title: (target: string) => `Kirim → ${target}`,
      targetKitchen: 'Dapur tujuan',
      delman: 'Delman',
      tabs: {
        product: 'Produk jadi',
        material: 'Bahan baku',
      },
      productQtyLabel: 'Qty per lot produksi',
      materialQtyLabel: 'Qty bahan baku',
      showAll: 'Tampilkan semua',
      hideZero: 'Sembunyikan stok 0',
      productionDate: (date: string) => `Prod. ${date}`,
      maxPcs: (n: number) => `max ${n} pcs`,
      maxUom: (n: number, uom: string) => `${uom} · max ${n}`,
      emptyProductTitle: 'Tidak ada stok produk',
      emptyProductDescription:
        'Produksi dulu atau pilih tab bahan baku jika yang dikirim bahan mentah.',
      emptyMaterial: 'Tidak ada stok bahan baku tersedia.',
      cancel: 'Batal',
      save: 'Simpan',
      continue: 'Lanjut',
    },
    review: {
      title: 'Review kiriman',
      destination: (kitchen: string, delman: string) =>
        `Ke ${kitchen} · Delman ${delman}`,
      materialSubtitle: 'Bahan baku',
      totalLabel: 'Total kirim',
      totalValue: (lines: number, qty: number) => `${lines} baris · ${qty} qty`,
      pcs: (n: number) => `${n} pcs`,
      back: 'Kembali',
      handover: 'Serah ke delman',
    },
    receiveList: {
      scanCta: 'Scan QR delman',
      pendingSection: 'Menunggu diterima',
      fromKitchen: (name: string) => `Dari ${name}`,
      needsScan: 'Perlu scan QR delman',
      emptyTitle: 'Belum ada kiriman masuk',
      emptyDescription:
        'Setelah delman scan di dapur asal, scan QR di sini lalu konfirmasi terima.',
    },
    scan: {
      title: 'Scan QR dari delman',
      description:
        'Delman menampilkan QR setelah barang diambil di dapur asal.',
      cameraHint: 'Arahkan kamera ke QR delman di layar handphone',
      cameraUnsupported:
        'Kamera QR tidak didukung di browser ini — gunakan input manual di bawah.',
      cameraPermissionDenied:
        'Izinkan akses kamera di pengaturan browser untuk scan QR.',
      manualToggle: 'Input manual token',
      liveBadge: 'Live',
      verifying: 'Memverifikasi scan…',
      tokenLabel: 'Token QR',
      tokenPlaceholder: 'SUPEROTI:KTH:…',
      verify: 'Verifikasi scan',
      cancel: 'Batal',
    },
    confirm: {
      title: (source: string) => `Terima dari ${source}`,
      meta: (code: string, delman: string) => `${code} · Delman ${delman}`,
      hint: 'Qty yang dikonfirmasi masuk stok dapur tujuan.',
      planned: (qty: number, unit: string) => `Rencana ${qty} ${unit}`,
      received: 'Diterima',
      matchPlan: 'Sesuai rencana',
      cancel: 'Batal',
      submit: 'Konfirmasi terima',
      productLine: (name: string, date: string) => `${name} · prod. ${date}`,
      materialLine: (name: string, uom: string) => `${name} (${uom})`,
    },
    pin: {
      dispatch: {
        title: 'PIN serah ke delman',
        description: 'Masukkan PIN 6 digit kepala dapur.',
        confirm: 'Serah ke delman',
      },
      receive: {
        title: 'PIN konfirmasi terima',
        description: 'Masukkan PIN 6 digit kepala dapur.',
        confirm: 'Konfirmasi terima',
      },
    },
    toast: {
      loadFailed: 'Gagal memuat data',
      noPeerKitchens: 'Belum ada dapur lain di brand ini.',
      noDelmans: 'Belum ada delman terdaftar.',
      draftSaved: 'Draft tersimpan.',
      saveFailed: 'Gagal menyimpan',
      dispatched: (syncQueued: boolean) =>
        syncQueued
          ? `Diserahkan ke delman. ${kitchenTerms.sync.queued}`
          : 'Diserahkan ke delman.',
      dispatchFailed: 'Gagal serah ke delman',
      scanTokenRequired: 'Masukkan token QR dari delman.',
      scanSuccess: (kitchen: string) =>
        `Scan berhasil — ${kitchen}. Buka dari daftar masuk.`,
      scanInvalid: 'QR tidak valid',
      scanBeforeReceive: 'Scan QR delman dulu sebelum konfirmasi terima.',
      received: (syncQueued: boolean) =>
        syncQueued
          ? `Transfer diterima. ${kitchenTerms.sync.queued}`
          : 'Transfer diterima.',
      receiveFailed: 'Gagal konfirmasi terima',
    },
    errors: {
      targetRequired: 'Pilih dapur tujuan.',
      delmanRequired: 'Pilih delman.',
      minOneLine: 'Isi minimal 1 produk atau bahan baku dengan qty lebih dari 0.',
    },
  },
  warehouseReceive: {
    title: 'Terima dari gudang',
    subtitle: 'Bahan baku dari gudang pusat — scan QR delman lalu konfirmasi jumlah',
    backHome: 'Kembali ke beranda',
    loading: 'Memuat kiriman gudang hari ini',
    loadError: 'Gagal memuat data gudang — periksa koneksi lalu coba lagi.',
    retry: 'Coba lagi',
    refreshAria: 'Perbarui kiriman gudang',
    mockHint: 'Mode mock — aktifkan API untuk data live.',
    flowSteps: ['Daftar', 'Scan QR', 'Konfirmasi'] as const,
    status: {
      inTransit: 'Dalam perjalanan',
      received: 'Sudah diterima',
    },
    summary: {
      materialCount: (n: number) => `${n} bahan baku`,
      join: (parts: string[]) => (parts.length === 0 ? 'Belum ada baris' : parts.join(' · ')),
    },
    list: {
      scanCta: 'Scan QR delman gudang',
      pendingSection: 'Menunggu diterima',
      doneSection: 'Sudah diterima',
      fromWarehouse: (name: string) => `Dari ${name}`,
      needsScan: 'Perlu scan QR delman gudang',
      emptyTitle: 'Belum ada kiriman gudang hari ini',
      emptyDescription:
        'Setelah delman gudang membawa QR bahan baku, scan di sini untuk mulai terima.',
    },
    scan: {
      title: 'Scan QR delman gudang',
      description: 'Delman gudang menampilkan QR setelah bahan baku diambil dari gudang pusat.',
      cameraHint: 'Arahkan kamera ke QR delman gudang di layar handphone',
      cameraUnsupported:
        'Kamera QR tidak didukung di browser ini — gunakan input manual di bawah.',
      cameraPermissionDenied:
        'Izinkan akses kamera di pengaturan browser untuk scan QR.',
      manualToggle: 'Input manual token',
      liveBadge: 'Live',
      verifying: 'Memverifikasi scan…',
      tokenLabel: 'Token QR',
      tokenPlaceholder: 'SUPEROTI:WDH:…',
      verify: 'Verifikasi scan',
      cancel: 'Batal',
    },
    confirm: {
      title: (warehouse: string) => `Terima bahan baku dari ${warehouse}`,
      meta: (code: string, delman: string) => `${code} · Delman ${delman}`,
      hint: 'Isi jumlah diterima (baik) dan rusak — sisa otomatis jadi kurang.',
      planned: (qty: number, uom: string) => `Rencana ${qty} ${uom}`,
      good: 'Diterima (baik)',
      goodHint: 'Masuk stok dapur',
      damaged: 'Rusak',
      damagedHint: 'Datang tapi tidak layak pakai',
      shortage: 'Kurang',
      shortageHint: 'Tidak ada di fisik / tidak diterima',
      equation: (good: number, damaged: number, shortage: number, uom: string) =>
        `${good} baik + ${damaged} rusak + ${shortage} kurang = rencana (${uom})`,
      matchPlan: 'Sesuai rencana',
      matchAllPlan: 'Semua sesuai rencana',
      statusOk: 'Sesuai',
      statusDiff: 'Ada selisih',
      summaryCounts: (ok: number, diff: number) => `${ok} sesuai · ${diff} selisih`,
      cancel: 'Batal',
      submit: 'Konfirmasi terima',
    },
    pin: {
      title: 'PIN konfirmasi terima gudang',
      description: 'Masukkan PIN 6 digit kepala dapur untuk menerima bahan baku dari gudang.',
      confirm: 'Konfirmasi terima',
    },
    toast: {
      loadFailed: 'Gagal memuat data gudang',
      scanTokenRequired: 'Masukkan token QR dari delman gudang.',
      scanInvalid: 'QR tidak valid, sudah dipakai, atau bukan untuk dapur ini.',
      scanBeforeReceive: 'Scan QR delman gudang dulu sebelum konfirmasi terima.',
      received: 'Bahan baku dari gudang diterima. Stok dapur diperbarui.',
      receiveFailed: 'Gagal konfirmasi terima bahan baku gudang',
    },
    forbidden: {
      title: 'Hanya kepala dapur',
      description:
        'Menerima bahan baku dari gudang hanya bisa dilakukan kepala dapur (HEAD_KITCHEN). Login sebagai kepala dapur untuk membuka menu ini.',
    },
  },
  warehouseReturn: {
    title: 'Retur ke gudang',
    subtitle: 'Kembalikan bahan baku sengaja dari dapur ke gudang pusat',
    backHome: 'Kembali ke beranda',
    loading: 'Memuat retur gudang hari ini',
    loadError: 'Gagal memuat data retur — periksa koneksi lalu coba lagi.',
    retry: 'Coba lagi',
    refreshAria: 'Perbarui daftar retur',
    mockHint: 'Mode mock — aktifkan API untuk data live.',
    flowSteps: ['Daftar', 'Isi barang', 'Publish', 'QR handover'] as const,
    status: {
      draft: 'Draft',
      readyForPickup: 'Siap diambil',
      pickedUp: 'Diambil delman',
      validated: 'Selesai',
    },
    summary: {
      materialCount: (n: number) => `${n} bahan baku`,
      join: (parts: string[]) => (parts.length === 0 ? 'Belum ada baris' : parts.join(' · ')),
    },
    list: {
      newReturn: 'Buat retur baru',
      draftSection: 'Draft',
      publishedSection: 'Sudah dipublish',
      toWarehouse: (name: string) => `Ke ${name}`,
      continueEdit: 'Lanjut edit draft',
      emptyTitle: 'Belum ada retur ke gudang hari ini',
      emptyDescription: 'Buat draft retur bahan baku yang akan dikembalikan ke gudang pusat.',
    },
    editor: {
      title: (warehouse: string) => `Retur ke ${warehouse}`,
      notesLabel: 'Catatan (opsional)',
      notesPlaceholder: 'Alasan retur, batch, dll.',
      materialQtyLabel: 'Qty bahan baku yang diretur',
      showAll: 'Tampilkan semua',
      hideZero: 'Sembunyikan nol',
      maxUom: (max: number, uom: string) => `Stok ${max} ${uom}`,
      emptyMaterial: 'Tidak ada stok bahan baku tersedia.',
      cancel: 'Batal',
      save: 'Simpan draft',
      continue: 'Lanjut publish',
    },
    review: {
      title: 'Konfirmasi publish retur',
      destination: (warehouse: string) => `Gudang tujuan: ${warehouse}`,
      notes: (text: string) => `Catatan: ${text}`,
      totalLabel: 'Total baris',
      totalValue: (lines: number, qty: number) => `${lines} baris · ${qty} qty`,
      back: 'Kembali edit',
      publish: 'Publish & tampilkan QR',
    },
    qr: {
      title: 'QR untuk delman gudang',
      description: 'Tampilkan QR ini ke delman gudang untuk scan pickup bahan retur.',
      expired: 'QR kedaluwarsa',
      remaining: (min: number, sec: string) => `Berlaku ${min}:${sec}`,
      done: 'Selesai',
      publishedToast: 'Retur dipublish. Tampilkan QR ke delman gudang.',
    },
    toast: {
      draftSaved: 'Draft retur disimpan.',
      saveFailed: 'Gagal simpan draft retur',
      publishFailed: 'Gagal publish retur',
      minOneLine: 'Isi minimal 1 bahan baku dengan qty lebih dari 0.',
    },
    forbidden: {
      title: 'Hanya kepala dapur',
      description:
        'Retur bahan baku ke gudang hanya bisa dilakukan kepala dapur (HEAD_KITCHEN). Login sebagai kepala dapur untuk membuka menu ini.',
    },
  },
  sync: {
    online: 'Online',
    offline: 'Offline',
    pending: (count: number) => `${count} menunggu sinkron`,
    queued: 'Tersimpan di tablet — akan disinkronkan saat online',
  },
  activation: {
    title: 'Aktivasi tablet dapur',
    subtitle: 'Masukkan kode aktivasi sekali pakai dari Admin HO.',
    codeLabel: 'Kode aktivasi',
    codeHelper: 'Ketik atau tempel 6 karakter dari Admin HO (tanpa strip).',
    codeVerifying: 'Memverifikasi kode…',
    previewReady: 'Periksa data binding di bawah sebelum aktivasi.',
    deviceNameLabel: 'Nama device',
    kitchenLabel: 'Dapur',
    loading: 'Memuat…',
    footer: 'Belum punya kode? Hubungi Admin HO.',
    cta: 'Aktivasi',
    verifying: 'Memverifikasi…',
    success: 'Perangkat teraktivasi',
    wrongDeviceType: 'Kode ini bukan untuk tablet dapur.',
    codeUnknown: 'Kode tidak dikenali.',
    activateFailed: 'Aktivasi gagal. Coba lagi.',
  },
  login: {
    title: 'Login PIN',
    subtitle: 'Masukkan PIN 6 digit kepala dapur untuk mulai operasional.',
    helper: 'Isi 6 digit PIN untuk lanjut.',
    submit: 'Masuk',
    submitting: 'Memverifikasi…',
  },
  home: {
    greeting: (name: string) => `Halo, ${name}`,
    greetingFallback: 'Halo',
    subtitle: (kitchenName: string, dateLabel: string) => `${kitchenName} · ${dateLabel}`,
    actionsTitle: 'Perlu tindakan hari ini',
    actionsCount: (count: number) => `${count} aksi`,
    emptyTitle: 'Semua modul sudah rapi',
    emptyDescription: 'Tidak ada yang perlu ditangani. Cek kembali setelah ada aktivitas baru.',
    menuTitle: 'Menu utama',
    statsTitle: 'Ringkasan hari ini',
    refreshLabel: 'Perbarui ringkasan',
    refreshLoading: 'Memperbarui…',
    loadError: 'Gagal memuat data terbaru — menampilkan data lokal.',
    retry: 'Coba lagi',
    loadSummary: 'Memuat ringkasan hari ini',
    sessionHint: 'Tablet ini untuk kepala dapur. Absensi tim lewat menu Absensi.',
    priority: {
      high: 'Prioritas',
      medium: 'Perlu dicek',
      low: 'Info',
    },
    stats: {
      attendance: 'sudah masuk',
      production: 'plan HO',
      dispatch: 'belum diserahkan',
      waste: 'siap dieksekusi',
    },
    menus: {
      production: (planPct: number, openSessions: number) =>
        `Plan HO ${planPct}% · ${openSessions} sesi terbuka`,
      dispatch: (pending: number) => `${pending} pengiriman perlu tindakan`,
      stock: 'Stok bagus, waste & bahan baku',
      kitchenTransfer: 'Kirim dan terima stok antar dapur',
      warehouseReceive: 'Scan & terima bahan baku dari gudang pusat',
      warehouseReturn: 'Retur bahan baku sengaja ke gudang pusat',
      waste: (ready: number) => `${ready} siap dieksekusi`,
      attendance: (checkedIn: number, total: number) =>
        `${checkedIn}/${total} sudah masuk`,
    },
  },
} as const
